// extracted by mini-css-extract-plugin
module.exports = {"tab-icon":"TabTitleWithIcon_tab-icon__11U1B"};